import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";
import styled from "@emotion/styled";

import { Flexbox } from "../../shared/components";

const PageSectionContainer = styled.div`
    height: 100%;
    padding: 32px 10px;
`;

const pageSectionHeight = css`
    width: 100%;
    height: 100%;
`;

interface PageSectionProps {
    sectionContainerClassName?: string;
    children?: ReactNode;
}

export const PageSection: FC<PageSectionProps> = ({ children, sectionContainerClassName }) => {
    return (
        <Flexbox justifyContent="center" className={pageSectionHeight}>
            <PageSectionContainer className={sectionContainerClassName}>{children}</PageSectionContainer>
        </Flexbox>
    );
};
